module.exports = __webpack_public_path__ + "img/mi-link.54753cd4.svg";